
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40.474","height":"39.465"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 818","transform":"translate(0 8.608)"}},[_c('path',{attrs:{"data-name":"Path 844","d":"M31.361 27.367L21.025 1.236A.843.843 0 0020.34.71L4.322-1.179a.831.831 0 00-.939.708v.031L.007 26.536a.843.843 0 00.727.945h.02l29.507 3.372h.1a.843.843 0 00.843-.764l.219-2.339a.841.841 0 00-.062-.383z","fill":"#ffc84d"}}),_c('path',{attrs:{"data-name":"Path 845","d":"M37.102-.441a.843.843 0 00-.935-.739h-.007l-7.25.853-21.415 2.52a.843.843 0 00-.744.922l2.527 26.978a.843.843 0 00.843.764h.1l29.507-3.372a.843.843 0 00.742-.934v-.011z","fill":"#ffe082"}}),_c('path',{attrs:{"data-name":"Path 846","d":"M24.461 4.507a.843.843 0 01-.9-1.271l3.17-5.049a.843.843 0 011.443.872l-.016.025-3.17 5.049a.843.843 0 01-.527.374z","fill":"#455a64"}}),_c('circle',{attrs:{"data-name":"Ellipse 77","cx":"4.215","cy":"4.215","r":"4.215","transform":"translate(25.129 -8.608)","fill":"#f44336"}})])])
          )
        }
      }
    